/* eslint-disable */
import Box from '@mui/material/Box';
import {
	POLYGON_COLOR,
	selectedMapItemColor,
} from 'modules/Telematics/constants';
import moment from 'moment';
import PolygonUnit from 'sharedMapComponents/PolygonUnit';

// TODO: Add a common component for MultiPolygons
const TelematicsPolygons = ({
	machinePolygonData,
	isCursorOverPoint,
	selectedPolygon,
}: {
	machinePolygonData: any;
	isCursorOverPoint?: boolean;
	selectedPolygon: any;
}) => {
	const getDuration = (start: any, end: any) => {
		const startDate = moment(start * 1000);
		const endDate = moment(end * 1000);
		const minutesDiff = endDate.diff(startDate, 'minutes');
		if (minutesDiff < 60) {
			return `${minutesDiff} minutes`;
		} else {
			const hours = Math.floor(minutesDiff / 60);
			const minutes = minutesDiff % 60;
			if (hours < 24) {
				return `${hours} hours ${minutes} minutes`;
			} else {
				const days = Math.floor(hours / 24);
				return `${days} days`;
			}
		}
	};

	const createTooltipData = (polygonData: any) => {
		const {
			placeId,
			startTime,
			endTime,
			polygonAcre,
			referenceAttributes,
		} = polygonData;
		const tooltipData = [];
		tooltipData.push(
			{
				label: 'placeId',
				value: placeId,
				type: 'INFO',
			},
			{
				label: 'acre',
				value: parseFloat(polygonAcre).toFixed(2),
				type: 'INFO',
			},
			{
				label: 'startDate',
				value: moment(startTime * 1000).format('MMM DD YYYY hh:mm a'),
				type: 'INFO',
			},
			{
				label: 'endDate',
				value: moment(endTime * 1000).format('MMM DD YYYY hh:mm a'),
				type: 'INFO',
			},
			{
				label: 'duration',
				value: getDuration(startTime, endTime),
				type: 'INFO',
			},
		);
		referenceAttributes.forEach((el: any) => {
			if (el.referenceType === 'DEVICE_REF_TYPE') {
				tooltipData.push({
					label: el.attributes[0].key,
					value: el.attributes[0].value.int64Value,
					type: 'INFO',
				});
			} else if (el.referenceType === 'MACHINE_REF_TYPE') {
				tooltipData.push({
					label: el.attributes[0].key,
					value: el.attributes[0].value.stringValue,
					type: 'INFO',
				});
			} else if (el.referenceType === 'RT_BOOKING') {
				tooltipData.push({
					label: 'Booking ID',
					value: el.attributes[0].value.int64Value,
					type: 'INFO',
				});
			}
		});
		return tooltipData;
	};

	return (
		<div>
			{machinePolygonData?.length &&
				machinePolygonData.map((polygonData: any, idx: any) => {
					if (polygonData?.polygonType === 'Polygon') {
						return (
							<Box key={`${polygonData.placeId}-${idx}`}>
								<PolygonUnit
									borderStoke={
										Number(selectedPolygon) ===
										Number(polygonData?.placeId)
											? selectedMapItemColor
											: POLYGON_COLOR
									}
									colorIndex={idx}
									showEditLinkOnTooltip={false}
									fillColor=""
									isCursorOverPoint={isCursorOverPoint}
									key={`${polygonData.placeId}-${idx}`}
									optionalTooltipData={createTooltipData(
										polygonData,
									)}
									paths={polygonData?.geometry}
									placeId={polygonData.placeId}
									polygonIndex={idx}
									polygonMetaData={polygonData.placeTags}
									strokeWeight={
										Number(selectedPolygon) ===
										Number(polygonData?.placeId)
											? 6
											: 4
									}
								/>
							</Box>
						);
					}
					// multipolygon
					const { geometry } = polygonData;
					if (geometry[polygonData?.placeId]) {
						return (
							<Box>
								{geometry[polygonData?.placeId].map(
									(multiPolygonData: any) => {
										return (
											<PolygonUnit
												borderStoke={
													Number(selectedPolygon) ===
													Number(polygonData?.placeId)
														? selectedMapItemColor
														: POLYGON_COLOR
												}
												strokeWeight={
													Number(selectedPolygon) ===
													Number(polygonData?.placeId)
														? 6
														: 4
												}
												colorIndex={idx}
												fillColor=""
												isCursorOverPoint={
													isCursorOverPoint
												}
												key={`${polygonData.placeId}-${idx}`}
												paths={multiPolygonData}
												placeId={polygonData.placeId}
												polygonIndex={idx}
												polygonMetaData={
													polygonData.placeTags
												}
												optionalTooltipData={createTooltipData(
													polygonData,
												)}
											/>
										);
									},
								)}
							</Box>
						);
					}
				})}
		</div>
	);
};

export default TelematicsPolygons;
